import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import {
	InsuranceContractOrderFieldV1,
	SortOrderTypeV1x0,
} from '../../../../api/generated/cz.pbktechnology.coop.bank.insurance.backoffice';
import { defaultPagingSchema } from '../../../../helpers/schemas/defaultPagingSchema';
import { clientProductsRoute } from '../route';

import { clientBankInsurancesFilterFormSchema } from './ClientBankInsurancesFilter/clientBankInsurancesFilterFormSchema';

const bankInsurancesSortSchema = z
	.object({
		name: z.enum([InsuranceContractOrderFieldV1.VALID_FROM]),
		order: z.enum([SortOrderTypeV1x0.ASC, SortOrderTypeV1x0.DESC]),
	})
	.catch({
		name: InsuranceContractOrderFieldV1.VALID_FROM,
		order: SortOrderTypeV1x0.DESC,
	});

export const clientBankInsurancesRoute = createRoute({
	path: '/bank-insurances',
	getParentRoute: () => clientProductsRoute,
	component: lazyRouteComponent(
		() => import('./ClientBankInsurancesPage'),
		'ClientBankInsurancesPage',
	),
	validateSearch: defaultPagingSchema.extend({
		openedInsurance: z.string().optional(),
		filter: clientBankInsurancesFilterFormSchema.optional(),
		order: bankInsurancesSortSchema,
	}),
});
